import { BoolFilter } from "gen/search/service/service_pb"
import { UUID } from "shared-ts/classes/uuid"
import { WebUrl } from "shared-web/lib/webUrl"

export function adminAccountsInternal(): WebUrl {
  return {
    pathname: "/admin/accounts/internal",
  }
}

export function adminAccountsExternal(): WebUrl {
  return {
    pathname: "/admin/accounts/external",
    query: { status: BoolFilter.TRUE.toString() },
  }
}

export function adminAccountsExternalTransaction(id: UUID | undefined): WebUrl {
  return {
    pathname: "/admin/accounts/external",
    query: id ? { id: id.toString() } : undefined,
  }
}

export function adminAccountsInternalTransaction(
  id: string | undefined
): WebUrl {
  return {
    pathname: "/admin/accounts/internal",
    query: id ? { id } : undefined,
  }
}
